import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { getCommonTealiumProps } from 'helpers/AccountHelper';
import { handleAnalytics, Events, SegmentPageProfileTypes } from '@foxcorp/delta-web-analytics';
import Header from '../Header';
import ForgotPasswordCTA from '../ForgotPasswordCTA';
import Style from './AppleLinking.module.scss';

const AppleLinking = ({
  appleLinkingError = '',
  createPasswordGenericError = '',
  createPasswordNewPassword = '',
  createPasswordNewPasswordError = null,
  createPasswordPasswordError = null,
  createPasswordShowNewPassword = null,
  headerProps = {},
  language = {
    profile_currentPwInputPlaceholder: '',
    profile_newPwInputPlaceholder: '',
    profile_passwordRequirementsText: '',
    profileEdit_submitButton: '',
    profile_passwordInvalidError: '',
  },
  onCTAClick = () => {},
  onCreatePassword = () => {},
  onFieldChange = e => e,
  forgotPasswordCTAProps,
  utagAccountSource,
}) => {
  const {
    profile_createNewPwInputPlaceholder: newPlaceholder,
    profile_createPasswordInfoSIWA: createPasswordInfo,
    profile_createProfileButton: linkButtonText,
    profile_passwordInvalidError: passwordInvalidError,
    profile_noProfileCTA: noProfileCTAtext,
    profile_createProfileHeader: profileHeadertext,
  } = language || {};

  let createPasswordInputNew = React.createRef();

  const handleOnCreatePasswordInputNew = e => {
    onFieldChange(e);
    if (createPasswordInputNew.current) {
      createPasswordInputNew.current.focus();
    }
  };

  const passwordNewVisibility = createPasswordShowNewPassword ? 'text' : 'password';

  let passwordErrorText;
  let passwordNewErrorText;

  if (createPasswordPasswordError) {
    passwordErrorText = passwordInvalidError;
  }
  if (createPasswordNewPasswordError) {
    passwordNewErrorText = passwordInvalidError;
  }

  useEffect(() => {
    handleAnalytics({
      event: Events.PROFILE_APPLE_ID_LINK_STARTED,
      payload: {
        page_profile_type: SegmentPageProfileTypes.APPLE,
        page_start_source: utagAccountSource,
      },
      tealiumPayload: {
        profile_type: SegmentPageProfileTypes.APPLE,
        page_start_source: utagAccountSource,
        ...getCommonTealiumProps(),
      },
    });
  }, [utagAccountSource]);

  return (
    <main className={Style.linkAccount}>
      <Header {...headerProps} />
      <div className={Style.accountLinkContainer}>
        <h1>{profileHeadertext}</h1>
        <div className={Style.createPasswordInfo}>{createPasswordInfo}</div>
        <div className={Style.error}>{createPasswordGenericError}</div>
        <div className={Style.passwordContainer}>
          <input
            className={Style.inputField}
            type="email"
            name="appleLinkingEmail"
            placeholder="Email Address"
            onChange={onFieldChange}
            autoCapitalize="none"
          />
        </div>
        <div className={Style.error}>{passwordErrorText}</div>
        <div className={Style.passwordContainer}>
          <input
            className={Style.inputField}
            type={passwordNewVisibility}
            name="createPasswordNewPassword"
            placeholder={newPlaceholder}
            value={createPasswordNewPassword}
            onChange={onFieldChange}
            ref={input => {
              createPasswordInputNew = input;
            }}
            autoCapitalize="none"
            autoComplete="off"
            autoCorrect="off"
            spellCheck={false}
          />
          <label className={Style.passwordLabel}>
            <input
              className={Style.inputField}
              name="createPasswordShowNewPassword"
              type="checkbox"
              value={createPasswordShowNewPassword}
              onChange={handleOnCreatePasswordInputNew}
            />
            <span />
          </label>
        </div>
        <div className={Style.error}>{passwordNewErrorText || appleLinkingError}</div>
        <button className={Style.createProfileButton} onClick={() => onCreatePassword(true)}>
          {linkButtonText}
        </button>
        <ForgotPasswordCTA {...forgotPasswordCTAProps} />
        <div className={Style.ctaText} onClick={onCTAClick}>
          {noProfileCTAtext}
        </div>
      </div>
    </main>
  );
};

AppleLinking.propTypes = {
  appleLinkingError: PropTypes.string,
  createPasswordGenericError: PropTypes.string,
  createPasswordNewPassword: PropTypes.string.isRequired,
  createPasswordNewPasswordError: PropTypes.bool,
  createPasswordPassword: PropTypes.string.isRequired,
  createPasswordPasswordError: PropTypes.bool,
  createPasswordShowNewPassword: PropTypes.bool.isRequired,
  forgotPasswordCTAProps: PropTypes.shape({}).isRequired,
  headerProps: PropTypes.shape({}).isRequired,
  language: PropTypes.shape({}).isRequired,
  onCreatePassword: PropTypes.func.isRequired,
  onCTAClick: PropTypes.func,
  onCreatePasswordBackClick: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  userEmail: PropTypes.string,
  utagAccountSource: PropTypes.string,
};

export default AppleLinking;
